import React from 'react';
import pt from 'prop-types';
import useOfferCoupon from '../../../hooks/useOfferCoupon';
import Spinner from '../../Spinner';
import styles from './OfferableCoupon.module.scss';
import Button from '../../Button/v2';
import { useCustomer } from '../../../contexts/CustomerContext';
import useStudent from '../../../hooks/useStudent';
import useCart from '../../../hooks/useCart';

export default function OfferableCoupon({ schoolId, studentId, onContinue }) {
  const { data: coupon, isLoading } = useOfferCoupon(studentId, schoolId);
  const { data: student } = useStudent({ studentId, schoolId, isEnrolled: true });
  const { customer, setCustomer } = useCustomer();

  const { data: cart } = useCart(customer?.cart?.id);

  const handleContinue = async () => {
    if (!customer?.cart) return;

    cart.couponId = coupon.id;

    await cart.save();

    setCustomer({
      ...customer,
      currentStudent: student,
      currentSchool: student.school,
      cart,
    });

    onContinue();
  };

  if (isLoading) return <div><Spinner /></div>;
  if (!coupon) return <span>No offers available at this time.</span>;

  return (
    <div className={styles.page}>
      <img alt="Coupon" className={styles.couponImg} src={coupon.imageUrl} />
      <div className={styles.info}>
        <h1>Use Coupon Code:</h1>
        <span>{coupon.code}</span>
        <Button disabled={!cart} onClick={handleContinue} variant="primary">Order Pictures</Button>
      </div>
    </div>
  );
}

OfferableCoupon.defaultProps = {
  onContinue: () => {},
};

OfferableCoupon.propTypes = {
  onContinue: pt.func,
  schoolId: pt.string.isRequired,
  studentId: pt.string.isRequired,
};
